module.exports = __webpack_public_path__ + "static/media/lafourchette-4.beda2019.png";